<template>
	<div>
		
		<div class="search d-flex align-items-center">
			<div class="w search-box d-flex align-items-center">
				<div class="logo d-flex align-items-center">
					<span class="qylogo"  @click="qyback()" ><img class="search-img" :src="logo" /></span>
					<div class="shop" v-if="mch && mch.id">
						<router-link :to="{path:'/'+route_url+'/qycgcart', query: {mch_id: mch.id}}" class="shop-name show-one-lines" v-text="mch.name"></router-link>
						<!-- <div class="shop-name show-one-lines" v-text="mch.name"></div> -->
						<div class="d-flex  align-items-center">
							<span class="show-one-lines" v-text="'地址：'+mch.address" v-if="mch.address"></span>
							<span class="show-one-lines" v-text="'评分：'+mch.score" v-if="!mch.address && mch.score"></span>
							<template v-if="false">
								<img class="shop-img" src="../../../assets/images/service.png" alt />
								<span>在线客服</span>
							</template>
						</div>
					</div>
				</div>
				<div class="search-c">
					<div class="search-item">
						<div class="box">
							<img class="img" src="../../../assets/images/search.png" alt />
							<input placeholder="搜索商品" class="search-input" type="text" v-model="searchtext" ref="searchtext" />
						</div>
						<div class="search-btn" @click="searchshop()">搜索</div>
						<div class="search-btn2" v-if="mch && mch.id && false">搜本店</div>
					</div>
				</div>
				<div class="cat" @click="cartgoto()">
					<img class="xia" src="../../../assets/images/cat.svg" alt /> 我的购物车
					<span v-text="carnum"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			mch: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				route_url: this.$store.state.route_url,
				// access_token : this.$store.state.qycg_user.access_token,
				login: {},
				// qycg_user:this.$store.state.qycg_user.basics,
				logo:window.localStorage.getItem('logo'),
				searchtext: '', //搜索商品
				carnum: 0, //购物车数量
			}
		},
		created() {
			console.log(window.localStorage.getItem('logo'),"logo")
			let that = this;
			this.common.loginType(this);
			this.common.getCommonInfo(this);
			this.login=JSON.parse(window.localStorage.getItem('qycgUserInfo'))
			if (this.login) {
				if(this.login.access_token){
					this.cartnumapi();
				}
			}
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key === 13) {
					
					if (that.$refs.searchtext.value) {
						that.searchshop();
					}
				}
			};
		},
		methods: {
			qyback(){
				this.$router.push({
					path: this.common.qycgrouter(this) + "/",
				});
			},
			// 购物车数量
			cartnumapi() {
				this.$api.shoppingNum({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
				}).then(res => {
					this.carnum = res.data
				}).catch(err => {
					// console.log(err);
				});
			},
			cartgoto() {
				this.$router.push(this.common.qycgrouter(this) + "/qycgcart");
			},
			// 搜索商品
			searchshop() {
				let searchname = this.$refs.searchtext.value;
				if (searchname == '') {
					this.$message({
						showClose: true,
						message: '搜索商品不可为空',
						type: 'warning',
						offset: 200,
						duration: 1000
					});
				} else {
					let parms = {
						keyword: searchname
					}
					if (this.catid) {
						parms.id = this.catid;
					}
					this.$router.push({
						path:this.common.qycgrouter(this) + "/qycglist",
						query: parms
					})

				}
			},

		}
	};
</script>

<style lang="scss" scoped>
	.search {
		height: 112px;
		background-color: #fff;
		width: 100%;

		.search-box {
			display: flex;
			height: 112px;
			// padding-top: 32px;
			box-sizing: border-box;

			.logo {
				>.qylogo {
					display: block;
					width: 187px;
					height: 55px;
					margin-right: 44px;
					cursor: pointer;
				}

				.logo-img {
					width: 187px;
					height: 55px;
					object-fit: contain;
					display: block;
				}
				.search-img {
					width: 187px;
					height: 55px;
					// width: auto;
					// height: auto;
					// object-fit: fill;
					// display: block;
					// margin: 0 auto;
					// max-width: 100%;
					// max-height: 100%;
				}


				.shop {
					width: 140px;
					position: relative;

					&::after {
						content: '';
						width: 1px;
						height: 55px;
						background: #ebebeb;
						position: absolute;
						top: -5px;
						left: -21px;
					}

					.shop-name {
						font-size: 14px;
						color: #666666;
						margin-bottom: 10px;
						font-weight: 500;
						display: block;
					}

					span {
						color: #999999;
					}

					.shop-img {
						width: 12px;
						height: 12px;
						margin-left: 20px;
						margin-right: 4px;
					}
				}
			}

			.search-c {
				margin-left: auto;

				.search-item {
					display: flex;

					.box {
						width: 310px;
						height: 36px;
						border: 2px solid #ff0008;
						box-sizing: border-box;
						display: flex;
						align-items: center;

						.img {
							height: 10px;
							width: 10px;
							margin-left: 10px;
							margin-right: 4px;
						}

						.search-input {
							width: 100%;
							height: 32px;
							// border: 0 none;
							// box-sizing: border-box;
						}
					}

					.search-btn {
						width: 90px;
						height: 36px;
						background-color: #ff0008;
						color: #fff;
						font-size: 18px;
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
					}

					.search-btn2 {
						width: 90px;
						height: 36px;
						background-color: #ff9010;
						color: #fff;
						font-size: 18px;
						margin-left: 4px;
						display: flex;
						justify-content: center;
						align-items: center;
					}
				}

				// .search-default {
				//   display: flex;
				//   margin-top: 8px;
				//   color: #b3b3b3;
				//   li {
				//     margin-right: 8px;
				//   }
				// }
			}

			.cat {
				height: 40px;
				width: 120px;
				border: 1px solid #ff0008;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #ff0008;
				box-sizing: border-box;
				margin-left: 32px;
				cursor: pointer;
				border-radius: 2px;
				position: relative;

				span {
					position: absolute;
					top: 3px;
					left: 23px;
					right: auto;
					display: inline-block;
					padding: 1px 3px;
					font-size: 12px;
					line-height: 12px;
					color: #fff;
					background-color: #e1251b;
					border-radius: 7px;
					min-width: 12px;
					text-align: center;
				}

				.xia {
					height: 18px;
					width: 18px;
					margin-right: 12px;
				}
			}
		}
	}
</style>
